import Progress from '../../../../../component/progress/Progress.component';
import { CardComponentInterface } from '../interface/CardComponentInterface';
import GridComponent from '../../../../../component/grid/GridComponent.component';
import CardBody from './CardBody.component';

const CardComponent = ({ data, request }: CardComponentInterface) => {

  if (request) {
    return <Progress open={request} />
  }

  return (
    <GridComponent spacing={3} margin="20px 0px 0px 0px">
      {data !== null && data.map((communicated: any, index: number) => {
        let title: string = `${communicated.title}`;
        let date: string = `${communicated.date}`;
        let subTitle: string = `${communicated.subTitle}`;
        let score: number | string = `${communicated.score}`;
        let id: string = `${communicated.id}`;
        let store: string = `${communicated.store}`;

        return (
          <CardBody title={title} date={date} subTitle={subTitle} score={score} key={index} assesment={id} store={store} />
        )
      })}
    </GridComponent>
  )
}

export default CardComponent;
